import { ShareAndEarnObject } from '../objects/shareAndEarnObject';

export const formatDateForCsv = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

export const convertToCsv = (data: ShareAndEarnObject[], t: (key: string) => string): string => {
  if (!data || data.length === 0) return '';

  const headers = [t('shareAndEarnCsvHelper.affiliateCode'), t('shareAndEarnCsvHelper.firstName'), t('shareAndEarnCsvHelper.lastName'), t('shareAndEarnCsvHelper.email'), t('shareAndEarnCsvHelper.createdDate'), t('shareAndEarnCsvHelper.status')];

  const rows = data.map((item) => [`"${item.affiliateCode}"`, `"${item.user.firstName}"`, `"${item.user.lastName}"`, `"${item.user.email}"`, `"${formatDateForCsv(item.createdAt)}"`, `"${item.status}"`]);

  return [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');
};

export const downloadCsv = (csvContent: string, filename: string = `report-share-and-earn-${Date.now()}.csv`): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};
